import { useCallback } from 'react';
export function useContactItem({ contact, onSelect, onToggleFavorite, onDelete, onResetSelection, }) {
    const handleToggleFavorite = useCallback((e) => {
        e.stopPropagation();
        onToggleFavorite(contact.id);
    }, [contact.id, onToggleFavorite]);
    const handleDelete = useCallback((e) => {
        e.stopPropagation();
        onDelete(contact.id);
    }, [contact.id, onDelete]);
    const handleSelect = useCallback(() => {
        onSelect(contact);
    }, [contact, onSelect]);
    const handleResetSelection = useCallback(() => {
        onResetSelection();
    }, [onResetSelection]);
    return {
        handleToggleFavorite,
        handleDelete,
        handleSelect,
        handleResetSelection,
    };
}
